
import Header from "./Headers";
import Const from "../util/Constants";
import Config from "../config/config";

class ColdDataApi {

  static getList = (id, success, failure) => {
    const link = id ? `api/cold-data/list/user/${id}` : 'api/cold-data/list';
    fetch(Config.app.link + link, new Header("GET"))
      .then((res) => Const.ProcessAPI(res, success, failure))
      .catch((er) => failure(er));
  };
  static getDeactivateList = (id, success, failure) => {
    const link = id ? `api/cold-data/deactivate/list/user/${id}` : 'api/cold-data/deactivate/list';
    fetch(Config.app.link + link, new Header("GET"))
    .then((res) => Const.ProcessAPI(res, success, failure))
    .catch((er) => failure(er));
  };

  static getUserList = (id, success, failure) => {
    fetch(Config.app.link + `api/cold-data/campaign/${id}`, new Header("GET"))
      .then((res) => Const.ProcessAPI(res, success, failure))
      .catch((er) => failure(er));
  };

  static getUserDataList = (id, filters = [{}], success, failure) => {
    fetch(Config.app.link + `api/cold-data/data/user/${id}`, new Header("POST", { filters }))
      .then((res) => Const.ProcessAPI(res, success, failure))
      .catch((er) => failure(er));
  };

  static getDataList = (id, success, failure) => {
    const link = id ? `/cold-data/list/user/${id}` : '/cold-data/list';
    fetch(Config.app.link + link, new Header("GET"))
      .then((res) => Const.ProcessAPI(res, success, failure))
      .catch((er) => failure(er));
  };

  static insertCampaign = (data, success, failure) => {
    fetch(
      Config.app.link + "api/colddata/campaign/add",
      new Header("POST", data)
    )
      .then((res) => Const.ProcessAPI(res, success, failure))
      .catch((er) => failure(er));
  };

  static insertCampaignAsync = (data) => {
    return new Promise((resolve, reject) => {
      ColdDataApi.insertCampaign(
        data,
        (res) => resolve(res),
        (err) => reject(err)
      );
    });
  };

  static DeleteNumber = (id, success, failure) => {
    fetch(Config.app.link + `api/cold-data/list/user/delete/${id}`, new Header("GET"))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(err => failure(err));
  };

  static addContactToCampaign = (contactData, success, failure) => {  
    fetch(Config.app.link + `api/cold-data/list/user/add`, new Header("POST", contactData))
      .then(res => {
        return Const.ProcessAPI(res, success, failure);
      })
      .catch(err => {
        console.error('API call failed:', err);
        failure(err);
      });
  };

  static DeactivateCampaign = (id, success, failure) => {
    fetch(Config.app.link + `api/cold-data/campaign/deactivate/${id}`, new Header("GET"))
      .then(res =>{
        return Const.ProcessAPI(res, success, failure)
      })
      .catch(err => {
        console.error('API call failed:', err);
        failure(err);
      });
  };

  static ActivateCampaign = (id, success, failure) => {
    fetch(Config.app.link + `api/cold-data/campaign/active/${id}`, new Header("GET"))
      .then(res =>{
        return Const.ProcessAPI(res, success, failure)
      })
      .catch(err => {
        console.error('API call failed:', err);
        failure(err);
      });
  };

  static renameCampaign = (id, body, success, failure) => {
    fetch(Config.app.link + `api/cold-data/campaign/rename/${id}`, new Header("POST", body))
      .then(res =>{
        return Const.ProcessAPI(res, success, failure)
      })
      .catch(err => {
        console.error('API call failed:', err);
        failure(err);
      });
  }
}

export default ColdDataApi;
